import { Api, ApiError, FullRequestParams, HttpResponse } from "./observeApi";
import { findUrlParts } from "./api.utils";

export let rootObsApi = new Api();
// api.baseUrl = `/api/obs/${api.baseUrl}`;
const internalRequestFunc = rootObsApi.request;
rootObsApi.request = async <T = any, E = any>({
  body,
  secure,
  path,
  type,
  query,
  format,
  baseUrl,
  cancelToken,
  ...params
}: FullRequestParams): Promise<HttpResponse<T, E>> => {
  const urlParts = findUrlParts(window.location.href.split("/"), [
    "sites",
    "resource",
  ]);

  const siteId = urlParts[0];
  const resourceID = urlParts[1];

  baseUrl = `/api/route/${siteId}/observe/${resourceID}${rootObsApi.baseUrl}`;
  const internalResp = internalRequestFunc({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params,
  });
  return internalResp.then(CommonAPIValidation);
};

export function CommonAPIValidation<D, E>(
  res: HttpResponse<D, E>,
): HttpResponse<D, E> {
  const err = res.error as ApiError;
  if (err && res.status === 403 && err.message === "invalid session") {
    document.location = "/";
  }
  return res;
}
